
import React, { useState, useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import * as Material from "@mui/material";
import { IconSearch } from "@tabler/icons-react";
import { Input, Button } from "@fragments";

export default function SearchBar({
    searchMode,
    setSearchMode,
    searchQueryRef,
    onSearch
}) {
    const { t } = useTranslation("banking");
    const searchInputRef = useRef(null);
    const [localValue, setLocalValue] = useState(searchQueryRef.current);

    const handleSearch = useCallback(() => {
        searchQueryRef.current = localValue; // Atualizar o valor global imediatamente
        onSearch();
    }, [localValue, onSearch, searchQueryRef]);

    const handleKeyPress = useCallback((event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    }, [handleSearch]);

    const handleBlur = useCallback(() => {
        if (localValue !== searchQueryRef.current) {
            handleSearch();
        }
    }, [handleSearch, localValue, searchQueryRef]);

    const handleChange = useCallback((e) => {
        setLocalValue(e); // Apenas atualizar o valor local
    }, []);

    return (
        <div className="searchbar mt-3">
            <div className="search-container">
                <Input.Text
                    ref={searchInputRef}
                    placeholder={t('search.placeholder', {
                        field: searchMode === 'email' ? t('search.fieldEmail') : t('search.fieldName'),
                    })}
                    value={localValue}
                    onInput={handleChange}
                    onKeyPress={handleKeyPress}
                    onBlur={handleBlur}
                    fullWidth
                    variant="large"
                    className="search-input"
                    start={
                        <div className="search-mode-toggle">
                            <Material.ToggleButtonGroup
                                value={searchMode}
                                exclusive
                                onChange={(e, newMode) => {
                                    if (newMode !== null) {
                                        setSearchMode(newMode);
                                    }
                                }}
                                size="small"
                                className="search-mode-toggle-group"
                            >
                                <Material.ToggleButton value="email">{t('search.modeEmail')}</Material.ToggleButton>
                                <Material.ToggleButton value="name">{t('search.modeName')}</Material.ToggleButton>
                            </Material.ToggleButtonGroup>
                        </div>
                    }
                    end={
                        <Button
                            color="text"
                            onClick={handleSearch}
                            icon={<IconSearch />}
                        />
                    }
                />
            </div>
        </div>
    )
}
